


























import { Teacher } from '../../../../src_server/entity/generated/Teacher';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { getTeacherSuffixInSession } from '../../../utils/building_trans';

@Component({ components: {} })
export default class DialgoHeader extends Vue {
  @Prop()
  teacher!: Teacher;

  gotoProfile() {
    console.log('DialgoHeader#gotoProfile');
    this.$emit('goto-profile');
  }
  get teacherSuffix() {
    return getTeacherSuffixInSession();
  }
}
